import { MemberShipTypeDTO } from "../dto/MembershipTypeDTO";
import { MembershipType } from "../models/MembershipType";

export const membershipTypeMapper = (data: MemberShipTypeDTO) => {
  return new MembershipType({
    id: data.membershipTypeId || null,
    programId: data.programId || null,
    name: data.membershipTypeName || null,
    displayName: data.membershipTypeDisplayName || null,
    active: data.active === "Y" ? true : false,
    duration: data.duration || null,
    expirationType: data.expirationType || null,
    price: data.price || null,
    oldDiscountType: data.oldDiscountType || null,
    gcEligible: data.gcEligible === "Y" ? true : false,
    availableOnline: data.availableOnline === "Y" ? true : false,
    haveGuest: data.canHaveGuestPrivs === "Y" ? true : false,
    gcRegCodeRowId: data.gcRegCodeRowId || null,
    ratingsRestricted: data.ratingsRestricted === "Y" ? true : false,
    taxable: data.taxable === "Y" ? true : false,
    renewalEligible: data.renewalEligible === "Y" ? true : false,
    displayOrder: data.displayOrder || null
  });
};
